export default __webpack_public_path__ + "static/media/visa.eaec2501.svg";